import { Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import axios from "helpers/axiosInstance";
import { composeApiURL } from "helpers/utility/axiosHelpers";

import { State } from "redux/store";
import {
  IS_CONTENT_LOADING,
  SET_SINGLE_IMAGE_DATA,
  SET_SINGLE_IMAGE_LABELS,
  SET_SINGLE_IMAGE_ISSUES,
  SET_SELECTED_OBJECT_LABELS,
  SET_HOVERED_OBJECT_LABEL,
  SET_IMAGE_CUSTOM_METADATA,
} from "./constants";
import { ImageCustomMetadata } from "types";

export const setContentLoader = (data: any) => {
  return {
    type: IS_CONTENT_LOADING,
    data,
  };
};

export const setSingleImageData = (data: any) => {
  return {
    type: SET_SINGLE_IMAGE_DATA,
    data,
  };
};

export const setSingleImageIssues = (data: any) => {
  return {
    type: SET_SINGLE_IMAGE_ISSUES,
    data,
  };
};

export const setSingleImageLabels = (data: any) => {
  return {
    type: SET_SINGLE_IMAGE_LABELS,
    data,
  };
};

export const setHoveredObjectLabel = (data: string | null) => {
  return {
    type: SET_HOVERED_OBJECT_LABEL,
    data,
  };
};

export const setSelectedObjectLabels = (data: any) => {
  return {
    type: SET_SELECTED_OBJECT_LABELS,
    data,
  };
};

export const setImageCustomMetadata = (data: ImageCustomMetadata[]) => {
  return { type: SET_IMAGE_CUSTOM_METADATA, data };
};

export const fetchSingleImageData = (
  id: any
): ThunkAction<void, State, unknown, any> => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(setSingleImageData(null));
      dispatch(setSingleImageIssues([]));
      dispatch(setSingleImageLabels([]));
      dispatch(setContentLoader(true));
      const url = composeApiURL(
        process.env.REACT_APP_API_ENDPOINT!,
        `/image/${id}`
      );
      const issuesUrl = composeApiURL(
        process.env.REACT_APP_API_ENDPOINT!,
        `/image/${id}/issues`
      );
      const labelUrl = composeApiURL(
        process.env.REACT_APP_API_ENDPOINT!,
        `/image/${id}/labels`
      );

      const dataResponse = await axios.get(url);
      const issuesResponse = await axios.get(issuesUrl);
      const labelResponse = await axios.get(labelUrl);
      dispatch(setSingleImageData(dataResponse.data));
      dispatch(setSingleImageIssues(issuesResponse.data));
      dispatch(setSingleImageLabels(labelResponse.data));
      dispatch(setContentLoader(false));
    } catch (error) {
      console.log(error);
    }
  };
};

export const fetchImageCustomMetadata = (
  datasetId: string,
  imageId: string
): ThunkAction<void, State, unknown, any> => {
  return async (dispatch: Dispatch) => {
    try {
      const url = composeApiURL(
        process.env.REACT_APP_API_ENDPOINT!,
        `/datasets/${datasetId}/image/${imageId}/custom_metadata`
      );

      const response = await axios.get(url);
      dispatch(setImageCustomMetadata(response.data || []));
    } catch (error) {
      console.log("Error fetching image custom metadata", error);
    }
  };
};
